import React from 'react'
import LpPartnersHead from './LpPartnersHead'
import HomePartnersCard from '../../HomePage/HomePartners/HomePartnersCard'

const LpPartners = () => {
  return (
    <div className='lpPartner-container'>
      <LpPartnersHead/>
      <HomePartnersCard/>
    </div>
  )
}

export default LpPartners
